module.exports = __webpack_public_path__ + "6ddd039642c5b782f4b1ef4260624e06.svg";